// Shared types for DocumentUpload component system
// Extracted to prevent circular dependencies

// Document types enum
export enum DocumentType {
  LICENSE = 'license',
  CERTIFICATE = 'certificate', 
  PERMIT = 'permit',
  INSURANCE = 'insurance',
  AGREEMENT = 'agreement',
  PDF = 'application/pdf',
  OTHER = 'other'
}

// Document status enum
export enum DocumentStatus {
  VALID = 'valid',
  EXPIRED = 'expired',
  PENDING_REVIEW = 'pending_review',
  REJECTED = 'rejected',
  PROCESSING = 'processing'
}

// Document metadata interface
export interface DocumentMetadata {
  id?: string
  title?: string
  author?: string
  createdDate?: Date
  pageCount?: number
  fileSize: number
  dpi?: number
  documentNumber?: string
  issuingAuthority?: string
  expirationDate?: Date
  keywords?: string[]
}

// Upload result interface
export interface UploadResult {
  id: string
  url: string
  filename: string
  size: number
  type: string
  success: boolean
  error?: string
  metadata?: DocumentMetadata
}

// Document item interface
export interface DocumentItem {
  id: string
  file: File
  url: string
  type: DocumentType
  status: DocumentStatus
  metadata?: DocumentMetadata
  uploadProgress?: number
  error?: string
  validationResult?: any // ValidationResult from DocumentValidator
}

// Document validation rule interface
export interface DocumentValidationRule {
  name: string
  validate: (file: File, metadata?: DocumentMetadata) => boolean | string
  message: string
}